import React, { useState } from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { Card, Tabs } from "@pankod/refine-antd";
import dayjs from "dayjs";
import { GlobalFilters } from "./components/GlobalFilters";
import { OverviewTab } from "./tabs/OverviewTab";
import { ShopAnalysisTab } from "./tabs/ShopAnalysisTab";
import { ProductAnalysisTab } from "./tabs/ProductAnalysisTab";
import { FiveGStatsTab } from "./tabs/FiveGStatsTab";
import { PrizmaScreensTab } from "./tabs/PrizmaScreensTab";

// Prizma sekmesi canlı durum gösterir; tarih ve kiosk mağaza filtreleri burada gizlenir.
const PRIZMA_TAB_KEY = "4";

export const KioskAnalyticsDashboard: React.FC<
  IResourceComponentsProps
> = () => {
  const [activeKey, setActiveKey] = useState<string>("0");
  const [dateRange, setDateRange] = useState<[string, string]>([
    dayjs().subtract(30, "day").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [shopCode, setShopCode] = useState<string | null>(null);

  const filterProps = { dateRange, shopCode };

  const items = [
    {
      key: "0",
      label: "Genel Bakış",
      children: activeKey === "0" ? <OverviewTab {...filterProps} /> : null,
    },
    {
      key: "1",
      label: "Mağaza Analizi",
      children: activeKey === "1" ? <ShopAnalysisTab {...filterProps} /> : null,
    },
    {
      key: "2",
      label: "Ürün Analizi",
      children: activeKey === "2" ? <ProductAnalysisTab {...filterProps} /> : null,
    },
    {
      key: "3",
      label: "5G İstatistikleri",
      children: activeKey === "3" ? <FiveGStatsTab {...filterProps} /> : null,
    },
    {
      key: PRIZMA_TAB_KEY,
      label: "Prizma Ekranları",
      children: activeKey === PRIZMA_TAB_KEY ? <PrizmaScreensTab /> : null,
    },
  ];

  return (
    <Card style={{ marginBottom: 10 }} bodyStyle={{ minHeight: "500px" }}>
      {activeKey !== PRIZMA_TAB_KEY && (
        <GlobalFilters
          dateRange={dateRange}
          setDateRange={setDateRange}
          shopCode={shopCode}
          setShopCode={setShopCode}
        />
      )}
      <Tabs activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
        {items.map((item) => (
          <Tabs.TabPane tab={item.label} key={item.key}>
            {item.children}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Card>
  );
};
